import React from 'react';
import cx from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { subYears } from 'date-fns';

import { Tooltip } from '@trqk/components';
import { formatNumberCompact, locale } from '@trqk/utils';
import { getDetectionsTablePathForProductionCo } from '../../../../../../utils';
import { DataCardRow } from '../components';

const earningsColor = 'quarternary';

interface DetectionsByProductionCompanyRowProps {
    datum: InsightProductionSummaryData;
    index: number;
}

const titleClasses = 'font-medium truncate';

export const DetectionsByProductionCompanyRow = ({
    datum,
    index,
}: DetectionsByProductionCompanyRowProps): JSX.Element => {
    const { detection_count, program_production_company } = datum;

    const now = new Date();

    const { search } = useLocation();

    const detectionsTablePath = getDetectionsTablePathForProductionCo({
        dateEnd: now,
        dateLabel: locale.enUS.DATE_RANGES.PAST_YEAR,
        dateStart: subYears(now, 1),
        programProductionCompany: program_production_company,
        search,
    });

    return (
        <DataCardRow index={index}>
            <Tooltip
                message={program_production_company}
                position="bottom"
                background="light"
            >
                <div
                    className={cx('grid', {
                        underline: detectionsTablePath !== null,
                    })}
                >
                    {detectionsTablePath && (
                        <Link className={titleClasses} to={detectionsTablePath}>
                            {program_production_company}
                        </Link>
                    )}
                    {!detectionsTablePath && (
                        <div className={titleClasses}>
                            {program_production_company}
                        </div>
                    )}
                </div>
            </Tooltip>
            <span className={`ml-2 font-semibold text-${earningsColor}-500`}>
                {formatNumberCompact(detection_count)}
            </span>
        </DataCardRow>
    );
};
